import { makeStyles, styled, Tooltip, withStyles } from "@material-ui/core";
import { Linked, useBoundLink, useLinked } from "@type-r/react";
import { PrimaryButton, Button, div, FormSelect, Option, Input, span, BaseCheckbox, Column } from "lqx-react";
import React, { useEffect, useRef } from "react";
import { getAuthorizationBearer, getPlatformCode } from "./api/endpoint";

export const InputWithMask = ({ onBlur, mask, number, $value, ...props }: { onBlur?, mask: string, number, $value }) => {
    const $isEditing = useLinked(false);
    const realInputParentRef = useRef(null);
    const $mask = useBoundLink(mask);

    useEffect(() => {
        if (realInputParentRef.current) realInputParentRef.current.querySelector('input').focus()
    }, [ $isEditing.value ]);

    const onRealInputBlur = (e) => {
        $isEditing.set(false);
        if(onBlur) onBlur(e);
    }

    const onReadInputFocus = () => {
        $isEditing.set(true);

    }

    return <>
        <div hidden={ !$isEditing.value } ref={ realInputParentRef }><div ><Input number={ number } { ...props } $value={ $value } onBlur={ onRealInputBlur } /></div></div>
        <ReadValueContainer hidden={ $isEditing.value }>
            <Input { ...props } { ...{ onFocus: onReadInputFocus } } $value={ $mask } />
        </ReadValueContainer>
    </>
}

const ReadValueContainer = div({
    '& input': {
        textAlign: 'right'
    }
});

export const WorkflowBody = div({
    marginTop: 15,
    paddingBottom: '70px'
});

export const WorkflowTitle = div({
    marginLeft: 5,
    marginTop: 10,
    color: '#3d6889',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: 600,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textTransform: 'capitalize'
});

export const WorkflowRow = div({
    marginBottom: 20
});

export const WorkflowFooter = div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    position: 'fixed',
    bottom: '0px',
    right: '0px',
    left: '0px',
    // width: '100%',
    minHeight: '3vh',
    background: 'white',
    // marginLeft: '16px',
    paddingTop: '10px'
});

export const WorkflowColumn = styled(Column)({
    minWidth: '400px'
});

export const RightAlignedButtons = div({
    marginLeft: 'auto',
    marginRight: '0px'
});

export const BackButton = styled(Button)({
    fontFamily: 'Montserrat',
    fontSize: 12,
    marginBottom: '10px',
    backgroundColor: 'white',
    color: 'gray',
    borderRadius: '20px',
    border: '1px solid',
    height: '25px',
    minWidth: '200px',
    marginLeft: 'auto'
});

export const CancelButton = styled(Button)({
    fontFamily: 'Montserrat',
    fontSize: 12,
    marginBottom: '10px',
    backgroundColor: 'transparent',
    color: '#4197d6',
    borderRadius: '20px',
    border: '0px',
    height: '25px',
    width: 'fit-content',
    '&:hover': {
        fontFamily: 'Montserrat',
        fontSize: 12,
        marginBottom: '10px',
        backgroundColor: 'transparent',
        color: '#4197d6',
        borderRadius: '20px',
        border: '0px',
        height: '25px',
    },
    '&:active': {
        fontFamily: 'Montserrat',
        fontSize: 12,
        marginBottom: '10px',
        backgroundColor: 'transparent',
        color: '#4197d6',
        borderRadius: '20px',
        border: '0px',
        height: '25px',
    },
    '&:focus': {
        fontFamily: 'Montserrat',
        fontSize: 12,
        marginBottom: '10px',
        backgroundColor: 'transparent',
        color: '#4197d6',
        borderRadius: '20px',
        border: '0px',
        height: '25px',
    }
});

export const ConfirmationButton = styled(PrimaryButton)({
    marginBottom: '10px',
    border: '0px',
    color: 'white',
    borderRadius: '10px',
    height: '25px',
    minWidth: '200px',
    marginLeft: 'auto'
});

export const StartOverButton = styled(Button)({
    minWidth: '200px',
    marginBottom: '5px'
});

export const ViewImportJobButton = styled(Button)({
  minWidth: '200px',
  marginBottom: '5px'
});

export const ContinueButton = styled(Button)({
    minWidth: '200px',
    minHeight: '25px',
    marginBottom: '10px'
});

export const YesNoSelect = ({ onBlur, $value }) => {
    const $localValue = useLinked($value.value ? 'yes' : 'no');

    useEffect(() => $value.set($localValue.value == 'yes'), [ $localValue.value ]);

    return <FormSelect { ...{ onBlur: onBlur } } $value={ $localValue } >
        <Option value="yes">Yes</Option>
        <Option value="no">No</Option>
    </FormSelect>
}


export const ErrorHighligter = ({ children, error, classes }: { children: JSX.Element, error: String, classes?: any }) => {
    const classAggregator = classes ? classes : makeErrorHighlighterStyles();

    return error ? <DigiTooltip title={ error }>
        < div className={ classAggregator.root } >
            { children }
        </div >
    </DigiTooltip > : <>{ children }</>
}

const makeErrorHighlighterStyles = makeStyles({
    root: {
        paddingLeft: '5px',
        paddingRight: '5px',
        border: '3px solid #ffdf71',
        borderRadius: '10px'
    }
});

export const DigiTooltip = withStyles({
    tooltip: {
        color: 'white',
        backgroundColor: '#3a7eac',
        padding: 10,
        fontFamily: 'Montserrat',
        fontSize: 12,
        fontWeight: 600
    },
    arrow: {
        color: '#3a7eac',
    },
})(
    ({ ...props }: any) =>
        <Tooltip
            placement="left-end"
            arrow={ true }
            { ...props }
        />
);

export const ErrorsContainer = div({
    padding: '10px',
    backgroundColor: 'white',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontSize: '12px',
    color: 'red',
    border: '1px solid red',
    marginTop: '10px',
    marginBottom: '10px',
    maxHeight: '100px',
    overflow: 'scroll'
});

export const ErrorView = span({
    color: 'red',
    display: 'block'
});

export const DigiDateInput = withStyles({
    input: {
        '&.date-picker': {
            zIndex: '1000',
            paddingRight: '23px',
            marginRight: '5px',
            backgroundOrigin: 'padding-box',
            backgroundPosition: 'right 5px bottom 10px',
            flex: 1
        }
    }
})(Input);

export const DigiCheckbox = withStyles({
    checkbox: {
        width: '18px',
        height: '18px',
        '& div': {
            width: '9px',
            height: '6px',
            borderColor: 'white'
        },
        backgroundColor: (props: any) => props.checked || (props.$checked && props.$checked.value) ? '#4D9ED8' : '',
        cursor: (props: any) => props.readOnly || props.disabled ? 'not-allowed' : '',
        borderRadius: '2px'
    },

})(BaseCheckbox);

export const asTimelessLinkedDate = ($date: Linked<Date>) => Linked.value(
    $date && $date.value ? new Date($date.value.getUTCFullYear(), $date.value.getUTCMonth(), $date.value.getUTCDate(), 0, 0, 0, 0) : null,
    x => $date.set(x ? new Date(Date.UTC(x.getFullYear(), x.getMonth(), x.getDate(), 0, 0, 0, 0)) : null));

export const limitText = (text, count) => text ? text.slice(0, count) + (text.length > count ? "..." : "") : '';

export const poll = async (fn, fnCondition, ms) => {
    let result = await fn();
    while (fnCondition(result)) {
        await wait(ms);
        result = await fn();
    }
    return result;
}

export const pollWithLimit = async (fn, fnCondition, ms, times) => {
    let result = await fn();    
    while (fnCondition(result) && times>0) {
        await wait(ms);
        result = await fn();
        times--;
    }
    return result;
}

export const wait = (ms = 1000) => {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
}

export const ErrorHighlighter = div({
  '& [class*="-error-"]': {
    border: '2px solid #ffdf71 !important',
    paddingLeft: '5px',
    borderRadius: '10px',
    paddingRight: '5px',
  },
  '& .error': {
    border: '2px solid #ffdf71 !important',
    paddingLeft: '5px',
    borderRadius: '10px',
    paddingRight: '5px',
    '& .select-root': {
      border: 'none !important',
    },
    '& .select-input-root': {
      border: 'none !important',
    },
    '& fieldset': {
        border: 'none !important',
      },
    '& [class*="errorIcon"]': {
      display: 'none'
    }
  },
});

export const downloadOriginalFile = async (url: string, fileName: string) => {
    const response = await fetch(url, {
        method: 'GET',
        headers: new Headers({
            "Authorization": getAuthorizationBearer(),
            "X-Platform-Code": getPlatformCode()
        })
    });

    const blob = await response.blob();

    const dataUrl = window.URL.createObjectURL(blob),
        a = document.createElement('a');

    a.href = dataUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
};

export const downloadInvoiceCsvReportFile = async (url: string, dateFrom: Date, dateTo: Date) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: new Headers({
            "Authorization": getAuthorizationBearer(),
            "X-Platform-Code": getPlatformCode(),
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            dateFrom: dateFrom,
            dateTo: dateTo,
         }),
    });

    const blob = await response.blob();

    const dataUrl = window.URL.createObjectURL(blob),
        a = document.createElement('a');

    a.href = dataUrl;
    a.download = 'invoice-report.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
};

export const preventDefaultAndStopPropagation = (event) => {
    event.preventDefault();
    event.stopPropagation();
}